<div class="terms-container">
  <div class="terms-header">Privacy Policy</div>
  <div>
    <div class="section-title">
      Introduction
      <p>
        We value the trust you place in us and recognize the importance of secure transactions and information privacy.
        This Privacy Policy describes how ArogyaLine and its affiliates (collectively "ArogyaLine, we,
        our, us") collect, use, share, protect or otherwise process your personal data through ArogyaLine website
        https://www.ArogyaLine.com. While you may be able to browse certain sections of the Platform without registering
        with us, however, please note we do not offer any product/service under this Platform outside India and your
        personal data will primarily be stored and processed in India. By visiting this Platform, providing your
        information or availing any product/service offered on the Platform, you expressly agree to be bound by the
        terms and conditions of this Privacy Policy, the Terms of Use and the applicable service/product terms and
        conditions, and agree to be governed by the laws of India including but not limited to the laws applicable to
        data protection and privacy. If you do not agree please do not use or access our Platform.
      </p>
    </div>

    <div class="section-title">
      Collection of Personal Data
      <p>
        We collect your personal data relating to your identity and demographics when you use our Platform, services, or
        otherwise interact with us during the course of our relationship and related information provided from time to
        time. Some of the information that we may collect includes, but is not limited to:
      </p>
      <ul>
        <li>
          Information provided to us during sign-up/registering or using our Platform such as name, date of birth,
          address, telephone/mobile number, email ID, and any such information shared as proof of identity or address.
        </li>
        <li>
          Sensitive personal data with your consent, such as your bank account, credit or debit card, or other payment
          instrument information, or biometric information such as your facial features or physiological information (to
          enable use of certain features when opted for, available on the Platform to assist you with your appointment
          booking experience) in accordance with applicable law.
        </li>
        <li>
          Information such as your appointment booking behavior, preferences, call data records, device location, voice,
          browsing history, and other information that you may provide to us from time to time.
        </li>
      </ul>
      <p>
        Our primary goal in collecting this information is to provide you with a safe, efficient, smooth, and customized
        experience. This allows us to provide services and features that most likely meet your needs and to customize
        our Platform to make your experience safer and easier.
      </p>
      <p>
        In general, you can browse the Platform without telling us who you are or revealing any personal data about
        yourself. Once you give us your personal data, you are not anonymous to us. Where possible, we indicate which
        fields are required and which fields are optional. You always have the option to not provide information by
        choosing not to use a particular service or feature on the Platform.
      </p>
      <p>
        We may track your behavior, preferences, and other information that you choose to provide on our Platform. We
        use this information to conduct research on our users' demographics, interests, and behavior to better
        understand and serve our users. This information is compiled and analyzed on an aggregated basis.
      </p>
      <p>
        If you enroll in our loyalty program or participate in third-party loyalty programs offered by us, we will
        collect and store your personal data such as name, contact number, email address, communication address, date of
        birth, gender, zip code, lifestyle information, demographic and work details, which is provided by you to us or
        a third-party business partner. We will also collect information related to your transactions on the Platform
        and such third-party business partner platforms.
      </p>
      <p>
        When such a third-party business partner collects your personal data directly from you, you will be governed by
        their privacy policies. We shall not be responsible for the third-party business partner’s privacy practices or
        the content of their privacy policies, and we request you to read their privacy policies before disclosing any
        information.
      </p>
      <p>
        If you set up an account or transact with us, we may seek some additional information, such as billing address,
        and/or other payment instrument details to provide
        services, enable transactions, or to refund for canceled transactions.
      </p>
      <p>
        If you choose to post messages on our message boards, personalized messages, images, photos, chat rooms, or
        other message areas or leave feedback/reviews, or if you use voice commands on the Platform, we will collect
        that information you provide to us. Please note such messages posted by you will be in the public domain and can
        be read by others as well. Please exercise caution while posting such messages, personal details, photos, and
        reviews.
      </p>
      <p>
        We retain this information as necessary to resolve disputes, provide customer support, conduct internal
        research, and troubleshoot problems as permitted by law.
      </p>
      <p>
        If you send us personal correspondence, such as emails or letters, or if other users or third parties send us
        correspondence about your activities or postings on the Platform, we may collect such information into a file
        specific to you.
      </p>
      <p>
        While you can browse some sections of our Platform without being a registered member, certain activities (such
        as booking an appointment or participating in any event) require registration. We may use your contact
        information to send you offers based on your previous appointments or preferences and your interests.
      </p>
      <p>
        If you receive an email or a call from a person/association claiming to be from ArogyaLine seeking any personal
        data like debit/credit card PIN, net-banking, or mobile banking password, we request you to never provide such
        information. We at ArogyaLine or our affiliate logistics partner do not at any time connect with you requesting
        such information. If you have already revealed such information, report it immediately to the appropriate law
        enforcement agency.
      </p>
    </div>

    <div class="section-title">
      Use of Personal Data
      <p>
        We use personal data to provide the services you request. To the extent we use your personal data to market to
        you, we will provide you with the ability to opt-out of such uses. We use your personal data to assist
        healthcare professionals and business partners in handling and fulfilling appointments, enhance customer
        experience, resolve disputes, troubleshoot problems, help promote a safe service, collect payments, measure
        consumer interest in our services, inform you about online and offline offers, services, and updates, customize
        your experience, detect and protect us against error, fraud, and other criminal activity, enforce our terms and
        conditions, conduct marketing research, analysis and surveys, and as otherwise described to you at the time of
        collection of information.
      </p>
      <p>
        We will ask for your permission to allow us access to your text messages (SMS), instant messages, contacts in
        your directory, camera, photo gallery, location, and device information: (i) to send commercial communication
        regarding your appointments or other services (ii) enhance your experience on the platform and provide you
        access to the services offered on the Platform by healthcare professionals, affiliates, partners, or lending
        partners. You understand that your access to these services may be affected in the event permission is not
        provided to us.
      </p>
      <p>
        In our efforts to continually improve our service offerings, we collect and analyze demographic and profile data
        about users' activity on our Platform. We identify and use your IP address to help diagnose problems with our
        server and to administer our Platform. Your IP address is also used to help identify you and to gather broad
        demographic information.
      </p>
      <p>
        We will occasionally ask you to complete surveys conducted either by us or through a third-party market research
        agency. These surveys may ask you for personal data, contact information, gender, date of birth, demographic
        information (like pin code, age or income level), attributes such as your interests, household or lifestyle
        information, your appointment booking behavior or history, and other such information that you may choose to
        provide. The survey may involve the collection of voice data or video recordings. Participation in these surveys
        is purely voluntary in nature. We use this data to tailor your experience on our Platform, providing you with
        content that we think you might be interested in and to display content according to your preferences.
      </p>
    </div>

    <div class="section-title">
      Links to Other Sites
      <p>
        Our Platform links to other websites that may collect personal data about you. ArogyaLine is not responsible for
        the
        privacy practices or the content of those linked websites.
      </p>
    </div>
    <div class="section-title">
      Security Precautions
      <p>
        To protect your personal data from unauthorised access or disclosure, loss or misuse we adopt reasonable
        security practices and procedures, in line with international standards ISO/IEC 27001:2013 which is recognised
        as one of the highest information security standards. Whenever you access your account information, we offer the
        use of a secure server. The transmission of information is not completely secure for reasons beyond our control.
        We adopt industry standard security measures and keep updating our systems from time to time to protect your
        personal data against any hacking or virus dissemination. However, by using the Platform, the users accept the
        security implications of data transmission over the internet and the World Wide Web which cannot always be
        guaranteed as completely secure, and therefore, there would always remain certain inherent risks regarding use
        of the Platform. Users are responsible for ensuring the protection of login and password records for their
        account.
      </p>
    </div>
    <div class="section-title">
      Choice/Opt-Out
      <p>
        We provide all users with the opportunity to opt-out of receiving non-essential (promotional, marketing-related)
        communications from us after setting up an account. If you do not wish to receive promotional communications
        from us, then please unsubscribe by clicking on the unsubscribe link in the email or visit our Help Center at
        here to unsubscribe/opt-out.
      </p>
    </div>
    <div class="section-title">
      Use of Children Information
      <p>
        Use of our Platform is available only to persons who can form a legally binding contract under the Indian
        Contract Act, 1872. We do not knowingly solicit or collect personal data from children under the age of 18
        years. If you have shared any personal data of children under the age of 18 years, you represent that you have
        the authority to do so and permit us to use the information in accordance with this Privacy Policy.
      </p>
    </div>
    <div class="section-title">
      Data Deletion and Retention
      <p>
        You have the option to delete your account by visiting your Profile and Settings on the mobile application. This
        action will result in the loss of all information related to your account. You can also write to us at the
        contact information provided below to assist you with these requests. By deleting your account, you will not be
        able to access your appointment history, preferences, details of any pending appointments, or benefits from
        loyalty programs. In the event of any pending grievances, claims, pending appointments, or any other services,
        we may refuse or delay the deletion of the account.
      </p>
      <p>
        Please note that the deletion of your account will not be retroactive and will be in accordance with the terms
        of this Privacy Policy, related Terms of Use, and applicable laws. Once the account is deleted, you will lose
        access to it. To access the Platform again, you would need to register as a new user.
      </p>
      <p>
        We retain your personal data for a period no longer than is required for the purpose for which it was collected
        or as required under any applicable law. However, we may retain data related to you if we believe it may be
        necessary to prevent fraud or future abuse, to enable ArogyaLine to exercise its legal rights and/or defend
        against legal claims, or for other legitimate purposes. We may continue to retain your data in anonymized form
        for analytical and research purposes.
      </p>
    </div>
    <div class="section-title">
      Your Rights
      <p>
        We take every reasonable step to ensure that your personal data we process is accurate and, where necessary,
        kept up to date. If any of your personal data we process is inaccurate (having regard to the purposes for which
        they are processed) will either be erased or rectified. You may access, rectify, and update your personal data
        directly through the functionalities provided on the Platform. You have an option to withdraw your consent that
        you have already provided by writing to us at the contact information provided below. Please mention “for
        withdrawal of consent” in the subject line of your communication. We may verify such requests before acting upon
        your request. Please note, however, that withdrawal of consent will not be retroactive and will be in accordance
        with the terms of this Privacy Policy, related Terms of Use and applicable laws. Your withdrawal of consent may
        hamper your access to the Platform or restrict certain provision of our services to you for which we consider
        that information to be necessary.
      </p>
    </div>
    <div class="section-title">
      Consent
      <p>
        By visiting our Platform or by providing your information, you consent to the collection, use, storage,
        disclosure and otherwise processing of your information on the Platform in accordance with this Privacy Policy.
        If you disclose to us any personal data relating to other people, you represent that you have the authority to
        do so and permit us to use the information in accordance with this Privacy Policy. You, while providing your
        personal data over the Platform or any partner platforms or establishments, consent to us (including our other
        corporate entities, affiliates, lending partners, technology partners, marketing channels, business partners and
        other third parties) to contact you through SMS, instant messaging apps, call and/or e-mail for the purposes
        specified in this Privacy Policy. You have an option to withdraw your consent that you have already provided by
        writing to the Grievance Officer at the contact information provided below. Please mention “Withdrawal of
        consent for processing personal data” in your subject line of your communication. We will verify such requests
        before acting on our request. Please note, however, that withdrawal of consent will not be retroactive and will
        be in accordance with the terms of this Privacy Policy, related terms of use and applicable laws. In the event
        you withdraw consent given to us under this Privacy Policy, we reserve the right to restrict or deny the
        provision of our services for which we consider such information to be necessary.
      </p>
    </div>
    <div class="section-title">
      Changes to this Privacy Policy
      <p>
        Please check our Privacy Policy periodically for changes. We may update this Privacy Policy to reflect changes
        to our information practices. We will alert you to significant changes by posting the date our Privacy Policy
        got last updated, placing a notice on our Platform, or by sending you an email when we are required to do so by
        applicable law.
      </p>
    </div>
    <div class="section-title">
      Grievance
      <p>
        In accordance with Information Technology Act 2000 and rules made there under and the Consumer Protection
        (E-Commerce) Rules, 2020, the name and contact details of the Grievance are provided below:
      </p>
      <p>
        Mrs. Roshani Bendre
      </p>
      <p>
        ArogyaLine,
      </p>
      <p>
        Shivani Building, Sanjay Park, Lane number 6, Airport Road, Pune, Maharashtra : 411032, India
      </p>
      <p>
        <a href="mailto:support@ArogyaLine.com">support&#64;ArogyaLine.com</a>
      </p>
      <p>
        Phone: <a href="tel:918390857034">+918390857034</a>
      </p>
      <p>
        Time: Mon - Fri(9:00 - 18:00)
      </p>
      <p>
        Customer Support: You can reach our customer support team to address any of your queries or complaints by
        clicking
        the link: <a href="https://www.ArogyaLine.com/contactus">Contact Us</a>
      </p>
    </div>
    <div class="section-title">
      Queries
      <p>
        If you have a query, concern, or complaint in relation to collection or usage of your personal data under this
        Privacy Policy, please contact us at the contact information provided above.
      </p>
    </div>

    <p>
      Last updated: March 24, 2025.
    </p>
  </div>
</div>
